import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { publicHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { couponsApiPath } from './apiPath';

const GetCouponGoodsCategoriesRequestSchema = z
  .object({
    couponNo: z.number().int(),
  })
  .describe('GetCouponGoodsCategoriesRequest');

export type GetCouponGoodsCategoriesRequest = z.infer<typeof GetCouponGoodsCategoriesRequestSchema>;

export const CouponGoodsCategoryItemSchema = z
  .object({
    categoryCode: z.string(),
    categoryTitle: z.string(),
    goodsCount: z.number().int(),
  })
  .describe('CouponGoodsCategoryItem');

export type CouponGoodsCategoryItem = z.infer<typeof CouponGoodsCategoryItemSchema>;

export const GetCouponGoodsCategoriesDataSchema = z.object({
  list: z.array(CouponGoodsCategoryItemSchema),
});

export const GetCouponGoodsCategoriesResponseSchema = createApiResponseSchema(
  GetCouponGoodsCategoriesDataSchema,
);
export type GetCouponGoodsCategoriesResponse = z.infer<
  typeof GetCouponGoodsCategoriesResponseSchema
>;

export const fetchCouponGoodsCategories = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCouponGoodsCategoriesRequestSchema),
    async ({
      couponNo,
    }: GetCouponGoodsCategoriesRequest): Promise<GetCouponGoodsCategoriesResponse> =>
      executeStandardRequest(() =>
        publicHttpClient.get<GetCouponGoodsCategoriesResponse>(
          couponsApiPath.getCouponGoodsCategories(couponNo),
        ),
      ),
    validateApiResponse(GetCouponGoodsCategoriesResponseSchema),
  ),
);
